import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Sidebar(props) {
  const [lang] = useTranslation("language");
  const navigate = useNavigate();
  const role = props.role ? props.role : sessionStorage.getItem("User role");

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSalesMenuOpen, setIsSalesMenuOpen] = useState(false);
  const [isCustomerMenuOpen, setIsCustomerMenuOpen] = useState(false);
  const [isTerritoryMenuOpen, setIsTerritoryMenuOpen] = useState(false);
  const [path, setPath] = useState("");

  useEffect(() => {
    let path = window.location.pathname;
    setPath(path);
    let pathname = unescape(path).split("/")[1];
    if (
      pathname === "dailySelloutReport" ||
      pathname === "dailySelloutReportCA" ||
      pathname === "monthlySelloutReport" ||
      pathname === "monthlySelloutReportCA" ||
      pathname === "selloutRotationReportFacility" ||
      pathname === "selloutRotationReportWholeSaler"
    ) {
      setIsSalesMenuOpen(true);
    } else if (
      pathname === "" ||
      pathname === "parentChildFacility" ||
      pathname === "parentChildChange" ||
      pathname === "organizationCustomer" ||
      pathname === "personCustomer" ||
      pathname === "newCustomerRequest" ||
      pathname === "customerRequestStatus"
    ) {
      setIsCustomerMenuOpen(true);
    } else if (
      pathname === "territoryDefinition" ||
      pathname === "territoryAllocation"
    ) {
      setIsTerritoryMenuOpen(true);
    }
  }, []);

  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  return (
    <div className="sidebar">
      <div className="sideBarTitle">
      </div>
      <ul>
        {role === "Admin" && (
          <>
            <li onClick={() => setIsTerritoryMenuOpen(!isTerritoryMenuOpen)}>
              <a>
                <span className="menu-icon">
                  <img src="images/bxs-area.svg" alt="Menu" />
                </span>
                <span className="item-name">{lang("Menu.territory")}</span>
                {isTerritoryMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isTerritoryMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isTerritoryMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/territoryDefinition" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/territoryDefinition");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.territoryDefinition")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/territoryAllocation" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/territoryAllocation");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.territoryAllocation")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <span className="menu-icon">
                  <img src="images/bxs-user.svg" alt="Menu" />
                </span>
                <span className="item-name">{lang("Menu.customer")}</span>
                {isCustomerMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isCustomerMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/parentChildFacility" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/parentChildFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.parentChildFacility")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={path === "/parentChildChange" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/parentChildChange");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.parentChildChange")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/" ||
                          path === "/organizationCustomer" ||
                          path === "/organizationAttributeChange" ||
                          path === "/organizationClosure"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/organizationCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/personCustomer" ||
                          path === "/personAttributeChange" ||
                          path === "/affiliationChange" ||
                          path === "/affiliationRetirement" ||
                          path === "/newAffiliationRequest"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/personCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                    </a>
                  </li>
                  {/* <li>
                    <a
                      className={
                        path === "/demo" 
                      }
                      onClick={(e) => {
                        changeRoute(e, "/demo");
                      }}
                    >
                      <span className="menu-link">
                        Demo
                      </span>
                    </a>
                  </li> */}
                  <li>
                    <a
                      className={
                        path === "/newCustomerRequest" ||
                          path === "/organizationRequestResubmit" ||
                          path === "/organizationRequestEdit" ||
                          path === "/personRequestResubmit" ||
                          path === "/personRequestEdit" ||
                          path === "/affiliationRequestResubmit" ||
                          path === "/affiliationRequestEdit"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/newCustomerRequest");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/customerRequestStatus" ||
                          path === "/organizationCustomerDetails" ||
                          path === "/personCustomerDetails" ||
                          path === "/affiliationDetails"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/customerRequestStatus");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <span className="menu-icon">
                  <img src="images/bxs-report.svg" alt="Menu" />
                </span>
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={path === "/dailySelloutReport" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/dailySelloutReportCA" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReportCA");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySelloutCA")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReport" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReportCA" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReportCA");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySelloutCA")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportFacility"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportWholeSaler"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportWholeSaler");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByWholesaler")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className={path === "/dailyProgress" ? "active" : ""}
                onClick={(e) => {
                  changeRoute(e, "/dailyProgress");
                }}
              >
                <span className="menu-icon">
                  <img src="images/bxs-wrench.svg" alt="Menu" />
                </span>
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
        {role === "SalesManager" && (
          <>
            <li onClick={() => setIsTerritoryMenuOpen(!isTerritoryMenuOpen)}>
              <a>
                <img src="images/bxs-area.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.territory")}</span>
                {isTerritoryMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isTerritoryMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isTerritoryMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/territoryDefinition" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/territoryDefinition");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.territoryDefinition")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/territoryAllocation" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/territoryAllocation");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.territoryAllocation")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <img src="images/bxs-user.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.customer")}</span>
                {isCustomerMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isCustomerMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/parentChildFacility" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/parentChildFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.parentChildFacility")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={path === "/parentChildChange" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/parentChildChange");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.parentChildChange")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/" ||
                          path === "/organizationCustomer" ||
                          path === "/organizationAttributeChange" ||
                          path === "/organizationClosure"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/organizationCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/personCustomer" ||
                          path === "/personAttributeChange" ||
                          path === "/affiliationChange" ||
                          path === "/affiliationRetirement" ||
                          path === "/newAffiliationRequest"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/personCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/newCustomerRequest" ||
                          path === "/organizationRequestResubmit" ||
                          path === "/organizationRequestEdit" ||
                          path === "/personRequestResubmit" ||
                          path === "/personRequestEdit" ||
                          path === "/affiliationRequestResubmit" ||
                          path === "/affiliationRequestEdit"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/newCustomerRequest");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/customerRequestStatus" ||
                          path === "/organizationCustomerDetails" ||
                          path === "/personCustomerDetails" ||
                          path === "/affiliationDetails"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/customerRequestStatus");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <img src="images/bxs-report.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={path === "/dailySelloutReport" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReport" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportFacility"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className={path === "/dailyProgress" ? "active" : ""}
                onClick={(e) => {
                  changeRoute(e, "/dailyProgress");
                }}
              >
                <img src="images/bxs-wrench.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
        {role === "BusinessOperation" && (
          <>
            <li onClick={() => setIsTerritoryMenuOpen(!isTerritoryMenuOpen)}>
              <a>
                <img src="images/bxs-area.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.territory")}</span>
                {isTerritoryMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isTerritoryMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isTerritoryMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/territoryDefinition" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/territoryDefinition");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.territoryDefinition")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/territoryAllocation" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/territoryAllocation");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.territoryAllocation")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <img src="images/bxs-user.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.customer")}</span>
                {isCustomerMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isCustomerMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                  <ul>
                    <li>
                      <a
                          className={
                            path === "/parentChildFacility" ? "active" : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/parentChildFacility");
                          }}
                      >
                      <span className="menu-link">
                        {lang("Menu.parentChildFacility")}
                      </span>
                      </a>
                    </li>

                    <li>
                      <a
                          className={path === "/parentChildChange" ? "active" : ""}
                          onClick={(e) => {
                            changeRoute(e, "/parentChildChange");
                          }}
                      >
                      <span className="menu-link">
                        {lang("Menu.parentChildChange")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/" ||
                            path === "/organizationCustomer" ||
                            path === "/organizationAttributeChange" ||
                            path === "/organizationClosure"
                                ? "active"
                                : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/organizationCustomer");
                          }}
                      >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/personCustomer" ||
                            path === "/personAttributeChange" ||
                            path === "/affiliationChange" ||
                            path === "/affiliationRetirement" ||
                            path === "/newAffiliationRequest"
                                ? "active"
                                : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/personCustomer");
                          }}
                      >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/newCustomerRequest" ||
                            path === "/organizationRequestResubmit" ||
                            path === "/organizationRequestEdit" ||
                            path === "/personRequestResubmit" ||
                            path === "/personRequestEdit" ||
                            path === "/affiliationRequestResubmit" ||
                            path === "/affiliationRequestEdit"
                                ? "active"
                                : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/newCustomerRequest");
                          }}
                      >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/customerRequestStatus" ||
                            path === "/organizationCustomerDetails" ||
                            path === "/personCustomerDetails" ||
                            path === "/affiliationDetails"
                                ? "active"
                                : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/customerRequestStatus");
                          }}
                      >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                      </a>
                    </li>
                  </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <img src="images/bxs-report.svg" alt="Menu"/>
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                    <span className="right-icon">
                    <i className="bx bxs-chevron-down"/>
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                  <ul>
                    <li>
                      <a
                          className={path === "/dailySelloutReport" ? "active" : ""}
                          onClick={(e) => {
                            changeRoute(e, "/dailySelloutReport");
                          }}
                      >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/dailySelloutReportCA" ? "active" : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/dailySelloutReportCA");
                          }}
                      >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySelloutCA")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/monthlySelloutReport" ? "active" : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/monthlySelloutReport");
                          }}
                      >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/monthlySelloutReportCA" ? "active" : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/monthlySelloutReportCA");
                          }}
                      >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySelloutCA")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/selloutRotationReportFacility"
                                ? "active"
                                : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/selloutRotationReportFacility");
                          }}
                      >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                      </a>
                    </li>
                    <li>
                      <a
                          className={
                            path === "/selloutRotationReportWholeSaler"
                                ? "active"
                                : ""
                          }
                          onClick={(e) => {
                            changeRoute(e, "/selloutRotationReportWholeSaler");
                          }}
                      >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByWholesaler")}
                      </span>
                      </a>
                    </li>
                  </ul>
              )}
            </li>
            <li>
              <a
                  className={path === "/dailyProgress" ? "active" : ""}
                  onClick={(e) => {
                    changeRoute(e, "/dailyProgress");
                  }}
              >
                <img src="images/bxs-wrench.svg" alt="Menu"/>
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
        {role === "MR" && (
            <>
              <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <img src="images/bxs-user.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.customer")}</span>
                {isCustomerMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isCustomerMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/parentChildFacility" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/parentChildFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.parentChildFacility")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={path === "/parentChildChange" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/parentChildChange");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.parentChildChange")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/" ||
                          path === "/organizationCustomer" ||
                          path === "/organizationAttributeChange" ||
                          path === "/organizationClosure"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/organizationCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/personCustomer" ||
                          path === "/personAttributeChange" ||
                          path === "/affiliationChange" ||
                          path === "/affiliationRetirement" ||
                          path === "/newAffiliationRequest"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/personCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/newCustomerRequest" ||
                          path === "/organizationRequestResubmit" ||
                          path === "/organizationRequestEdit" ||
                          path === "/personRequestResubmit" ||
                          path === "/personRequestEdit" ||
                          path === "/affiliationRequestResubmit" ||
                          path === "/affiliationRequestEdit"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/newCustomerRequest");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/customerRequestStatus" ||
                          path === "/organizationCustomerDetails" ||
                          path === "/personCustomerDetails" ||
                          path === "/affiliationDetails"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/customerRequestStatus");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <img src="images/bxs-report.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={path === "/dailySelloutReport" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReport" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportFacility"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className={path === "/dailyProgress" ? "active" : ""}
                onClick={(e) => {
                  changeRoute(e, "/dailyProgress");
                }}
              >
                <img src="images/bxs-wrench.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
        {role === "CustomerDataAccess" && (
          <>
            <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <img src="images/bxs-user.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.customer")}</span>
                {isTerritoryMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isTerritoryMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/" ||
                          path === "/organizationCustomer" ||
                          path === "/organizationAttributeChange" ||
                          path === "/organizationClosure"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/organizationCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/personCustomer" ||
                          path === "/personAttributeChange" ||
                          path === "/affiliationChange" ||
                          path === "/affiliationRetirement" ||
                          path === "/newAffiliationRequest"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/personCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/newCustomerRequest" ||
                          path === "/organizationRequestResubmit" ||
                          path === "/organizationRequestEdit" ||
                          path === "/personRequestResubmit" ||
                          path === "/personRequestEdit" ||
                          path === "/affiliationRequestResubmit" ||
                          path === "/affiliationRequestEdit"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/newCustomerRequest");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/customerRequestStatus" ||
                          path === "/organizationCustomerDetails" ||
                          path === "/personCustomerDetails" ||
                          path === "/affiliationDetails"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/customerRequestStatus");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <img src="images/bxs-area.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={path === "/dailySelloutReport" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReport" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportFacility"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className={path === "/dailyProgress" ? "active" : ""}
                onClick={(e) => {
                  changeRoute(e, "/dailyProgress");
                }}
              >
                <img src="images/bxs-wrench.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
        {role === "AllUser" && (
          <>
            <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <img src="images/bxs-user.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.customer")}</span>
                {isTerritoryMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isTerritoryMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/" ||
                          path === "/organizationCustomer" ||
                          path === "/organizationAttributeChange" ||
                          path === "/organizationClosure"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/organizationCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/personCustomer" ||
                          path === "/personAttributeChange" ||
                          path === "/affiliationChange" ||
                          path === "/affiliationRetirement" ||
                          path === "/newAffiliationRequest"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/personCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/newCustomerRequest" ||
                          path === "/organizationRequestResubmit" ||
                          path === "/organizationRequestEdit" ||
                          path === "/personRequestResubmit" ||
                          path === "/personRequestEdit" ||
                          path === "/affiliationRequestResubmit" ||
                          path === "/affiliationRequestEdit"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/newCustomerRequest");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/customerRequestStatus" ||
                          path === "/organizationCustomerDetails" ||
                          path === "/personCustomerDetails" ||
                          path === "/affiliationDetails"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/customerRequestStatus");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <img src="images/bxs-area.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={path === "/dailySelloutReport" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReport" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportFacility"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className={path === "/dailyProgress" ? "active" : ""}
                onClick={(e) => {
                  changeRoute(e, "/dailyProgress");
                }}
              >
                <img src="images/bxs-wrench.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
        {role === "CA" && (
          <>
            <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <img src="images/bxs-user.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.customer")}</span>
                {isTerritoryMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isTerritoryMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/" ||
                          path === "/organizationCustomer" ||
                          path === "/organizationAttributeChange" ||
                          path === "/organizationClosure"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/organizationCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/personCustomer" ||
                          path === "/personAttributeChange" ||
                          path === "/affiliationChange" ||
                          path === "/affiliationRetirement" ||
                          path === "/newAffiliationRequest"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/personCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/newCustomerRequest" ||
                          path === "/organizationRequestResubmit" ||
                          path === "/organizationRequestEdit" ||
                          path === "/personRequestResubmit" ||
                          path === "/personRequestEdit" ||
                          path === "/affiliationRequestResubmit" ||
                          path === "/affiliationRequestEdit"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/newCustomerRequest");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/customerRequestStatus" ||
                          path === "/organizationCustomerDetails" ||
                          path === "/personCustomerDetails" ||
                          path === "/affiliationDetails"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/customerRequestStatus");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <img src="images/bxs-area.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={path === "/dailySelloutReport" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/dailySelloutReportCA" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReportCA");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySelloutCA")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReport" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReportCA" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReportCA");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySelloutCA")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportFacility"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportWholeSaler"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportWholeSaler");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByWholesaler")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className={path === "/dailyProgress" ? "active" : ""}
                onClick={(e) => {
                  changeRoute(e, "/dailyProgress");
                }}
              >
                <img src="images/bxs-wrench.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
        {role === "Wholesaler" && (
          <>
            <li onClick={() => setIsCustomerMenuOpen(!isCustomerMenuOpen)}>
              <a>
                <img src="images/bxs-user.svg" alt="Menu" />
                <span className="item-name">{lang("Menu.customer")}</span>
                {isTerritoryMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isTerritoryMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isCustomerMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={
                        path === "/" ||
                          path === "/organizationCustomer" ||
                          path === "/organizationAttributeChange" ||
                          path === "/organizationClosure"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/organizationCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.organizationCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/personCustomer" ||
                          path === "/personAttributeChange" ||
                          path === "/affiliationChange" ||
                          path === "/affiliationRetirement" ||
                          path === "/newAffiliationRequest"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/personCustomer");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.personCustomer")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/newCustomerRequest" ||
                          path === "/organizationRequestResubmit" ||
                          path === "/organizationRequestEdit" ||
                          path === "/personRequestResubmit" ||
                          path === "/personRequestEdit" ||
                          path === "/affiliationRequestResubmit" ||
                          path === "/affiliationRequestEdit"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/newCustomerRequest");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.newCustomerRequest")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/customerRequestStatus" ||
                          path === "/organizationCustomerDetails" ||
                          path === "/personCustomerDetails" ||
                          path === "/affiliationDetails"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/customerRequestStatus");
                      }}
                    >
                      <span className="menu-link">
                        {lang("Menu.customerRequestStatus")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li onClick={() => setIsSalesMenuOpen(!isSalesMenuOpen)}>
              <a>
                <img src="images/bxs-area.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.salesReports")}
                </span>
                {isSalesMenuOpen === true && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-down" />
                  </span>
                )}
                {isSalesMenuOpen === false && (
                  <span className="right-icon">
                    <i className="bx bxs-chevron-right" />
                  </span>
                )}
              </a>
              {isSalesMenuOpen && (
                <ul>
                  <li>
                    <a
                      className={path === "/dailySelloutReport" ? "active" : ""}
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/dailySelloutReportCA" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/dailySelloutReportCA");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.dailySelloutCA")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReport" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReport");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySellout")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/monthlySelloutReportCA" ? "active" : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/monthlySelloutReportCA");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.monthlySelloutCA")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportFacility"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportFacility");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByFacility")}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={
                        path === "/selloutRotationReportWholeSaler"
                          ? "active"
                          : ""
                      }
                      onClick={(e) => {
                        changeRoute(e, "/selloutRotationReportWholeSaler");
                      }}
                    >
                      <span className="menu-link">
                        {lang("SalesMenu.selloutRotationByWholesaler")}
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className={path === "/dailyProgress" ? "active" : ""}
                onClick={(e) => {
                  changeRoute(e, "/dailyProgress");
                }}
              >
                <img src="images/bxs-wrench.svg" alt="Menu" />
                <span className="item-name">
                  {lang("SalesMenu.emailSetting")}
                </span>
              </a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}

const mapStateToProps = (state) => ({
  language: state.organizationCustomer.language,
});

export default connect(mapStateToProps)(Sidebar);
